import {RouteConfig} from "vue-router";
import {LayoutCommon} from "@/shared/layout";

export const customerCareRoutes: Array<RouteConfig> = [
    {
        path: "/customer-care",
        component: LayoutCommon,
        name: "customerCareParent",
        children: [
            {
                path: "",
                component: () => import(/* webpackChunkName: "icons" */ "@/modules/privacy/CustomerCare/index.vue"),
                name: 'customerCare',
                meta: {
                    title: 'Chăm sóc khách hàng',
                    icon: 'contacts'
                }
            }
        ]
    },
]

export const qARoutes: Array<RouteConfig> = [
    {
        path: "/question-answer",
        component: LayoutCommon,
        name: "questionAnswerParent",
        children: [
            {
                path: "",
                component: () => import(/* webpackChunkName: "icons" */ "@/modules/privacy/QA/index.vue"),
                name: 'questionAnswer',
                meta: {
                    title: 'Khiếu nại bồi thường',
                    icon: 'question-circle'
                }
            }
        ]
    },
]

export const ruleRoutes: Array<RouteConfig> = [
    {
        path: "/rules",
        component: LayoutCommon,
        name: "ruleParent",
        children: [
            {
                path: "",
                component: () => import(/* webpackChunkName: "icons" */ "@/modules/privacy/Rule/index.vue"),
                name: 'rule',
                meta: {
                    title: 'Quy định gửi hàng',
                    icon: 'safety-certificate'
                }
            }
        ]
    },
]

export const tutorialRoutes: Array<RouteConfig> = [
    {
        path: "/tutorial",
        component: LayoutCommon,
        name: "tutorialParent",
        children: [
            {
                path: "",
                component: () => import(/* webpackChunkName: "icons" */ "@/modules/privacy/Tutorial/index.vue"),
                name: 'tutorial',
                meta: {
                    title: 'Điều khoản vận chuyển',
                    icon: 'snippets'
                }
            }
        ]
    },
]
